import { Restaurant } from "../interfaces/Catalogue";


export const haversine = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const openExternalDirections = (
  restaurant: Restaurant,
  userLocation: { lat: number; lng: number } | null
) => {
  const dest =
    restaurant.latitude !== 0
      ? `${restaurant.latitude},${restaurant.longitude}`
      : encodeURIComponent(restaurant.address ?? restaurant.nom);
  const origin = userLocation ? `${userLocation.lat},${userLocation.lng}` : "";
  const url = origin
    ? `https://www.google.com/maps/dir/${origin}/${dest}`
    : `https://www.google.com/maps/search/?api=1&query=${dest}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const userDotIcon = (): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <circle cx="14" cy="14" r="13" fill="#4285F4" fill-opacity="0.18"/>
    <circle cx="14" cy="14" r="7"  fill="#4285F4"/>
    <circle cx="14" cy="14" r="3"  fill="#fff"/>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

export const resolveLatLng = (
  r: Restaurant
): Promise<google.maps.LatLngLiteral | null> => {
  if (r.latitude !== 0 && r.longitude !== 0)
    return Promise.resolve({ lat: r.latitude, lng: r.longitude });
  if (!r.address) return Promise.resolve(null);
  return new Promise((resolve) => {
    new window.google.maps.Geocoder().geocode(
      { address: r.address! },
      (results, status) => {
        resolve(
          status === "OK" && results?.[0]
            ? {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
              }
            : null
        );
      }
    );
  });
};

export const buildInfoWindowHtml = (
  r: Restaurant,
  primaryColor: string,
  isSelected: boolean
): string => `
  <div style="font-family:system-ui,sans-serif;padding:2px;min-width:175px;">
    <p style="font-size:13px;font-weight:700;color:#111827;margin:0 0 3px;">${r.nom}</p>
    ${r.address ? `<p style="font-size:11px;color:#6b7280;margin:0 0 6px;">${r.address}</p>` : ""}
    <div style="display:flex;align-items:center;gap:6px;margin-bottom:8px;">
      <span style="font-size:10px;font-weight:600;padding:2px 6px;border-radius:5px;
        background:${r.isOpen ? "#d1fae5" : "#fee2e2"};
        color:${r.isOpen ? "#059669" : "#dc2626"};">
        ${r.isOpen ? "Ouvert" : "Fermé"}
      </span>
      ${r.tempsPrep > 0 ? `<span style="font-size:10px;color:#6b7280;">${r.tempsPrep} min</span>` : ""}
    </div>
    <div style="display:flex;gap:6px;flex-direction:column;">
      ${
        r.isOpen && !isSelected
          ? `<button id="msm-sel-${r.id}" style="flex:1;padding:6px;border-radius:7px;border:none;
              background:${primaryColor};color:#fff;font-size:12px;font-weight:600;cursor:pointer;">
              Choisir
            </button>`
          : isSelected
          ? `<p style="text-align:center;font-size:11px;font-weight:600;color:${primaryColor};margin:0;flex:1;">✓ Sélectionné</p>`
          : ""
      }

      <button id="msm-dir-${r.id}" style="padding:6px;border-radius:7px;
        border:1.5px solid #e5e7eb;background:#fff;color:#374151;
        font-size:12px;font-weight:600;cursor:pointer;">
        Ouvrir dans Google Maps
      </button>
    </div>
  </div>
`;